var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBundle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83549 17.0617L11.563 21.8847C11.824 22.0722 12.176 22.0722 12.437 21.8847L19.1645 17.0617C19.501 16.8207 19.578 16.3517 19.337 16.0152C19.096 15.6787 18.627 15.6012 18.2905 15.8427L12 20.3522L5.70949 15.8427C5.37299 15.6012 4.90398 15.6787 4.66298 16.0152C4.42198 16.3517 4.49899 16.8207 4.83549 17.0617ZM4.83549 12.6827L11.563 17.5057C11.824 17.6927 12.176 17.6927 12.437 17.5057L19.1645 12.6827C19.501 12.4412 19.578 11.9727 19.337 11.6362C19.096 11.2997 18.627 11.2222 18.2905 11.4637L12 15.9732L5.70949 11.4637C5.37299 11.2222 4.90398 11.2997 4.66298 11.6362C4.42198 11.9727 4.49899 12.4412 4.83549 12.6827ZM19.1645 8.30373C19.3595 8.16373 19.476 7.93924 19.4775 7.69924C19.479 7.45924 19.366 7.23323 19.173 7.09073L12.4455 2.12123C12.1805 1.92573 11.8195 1.92573 11.5545 2.12123L4.82698 7.09073C4.63398 7.23323 4.52098 7.45924 4.52248 7.69924C4.52398 7.93924 4.64049 8.16373 4.83549 8.30373L11.563 13.1267C11.824 13.3137 12.176 13.3137 12.437 13.1267L19.1645 8.30373ZM17.453 7.68473L12 11.5942L6.54698 7.68473L12 3.65723L17.453 7.68473Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundle);
export default __webpack_public_path__ + "static/media/bundle.a0a2fd481f4ded7d4a3a429a97355c0c.svg";
export { ForwardRef as ReactComponent };